<style lang="scss" scoped>
form .form-group {
  margin-right: 10px;
}

.table-loading {
  min-height: 250px;
}
</style>

<template>
  <section>
    <slot name="title"></slot>
    <form class="d-flex mb-3">
      <slot name="filter"></slot>
    </form>
    <div class="card card-table">
      <slot name="table-title"></slot>
      <div class="card-body">
        <div
          v-if="loading"
          class="table-loading d-flex justify-content-center align-items-center"
        >
          <i class="fas fa-sync fa-7x fa-spin"></i>
        </div>
        <table v-else-if="items.length > 0" class="table">
          <thead>
            <slot name="header">
              <tr>
                <th v-for="(header, index) in computedHeaders" :key="index">
                  {{ header }}
                </th>
              </tr>
            </slot>
          </thead>
          <tbody>
            <slot v-for="(item, index) in items" name="row" :item="item">
              <tr :key="index">
                <td v-for="(value, key) in item" :key="key">
                  {{ value }}
                </td>
              </tr>
            </slot>
          </tbody>
        </table>
        <div class="text-center m-3" v-else>Keine Daten gefunden</div>
      </div>
    </div>
  </section>
</template>

<script lang="babel">
export default {
  props: {
    url: {
      default: null,
      type: String,
      required: true,
    },
    headers: {
      default: null,
      type: Array,
      required: false,
    }
  },
  data() {
    return {
      items: [],
      page: 1,
      pages: 1,
      items_per_page: 20,
      fetchTimeout: null,
      filters: {},
    };
  },
  created() {
    this.fetch();
    this.$on('filter-update', ({value, name}) => {
      this.$set(this.filters, name, value);
    })
  },
  methods: {
    fetch() {
      clearTimeout(this.fetchTimeout);

      this.fetchTimeout = setTimeout(() => {
        this.$http.get(this.computedUrl).then(({data}) => {
          this.items = data.data;
          this.page = data.current_page;
          this.pages = data.total;
          this.items_per_page = data.per_page;
        })
        .catch(() => {
          this.items = [];
        })
        .finally(() => {
          this.fetchTimeout = null;
        });
      }, 400);
    }
  },
  computed: {
    computedHeaders() {
      if (this.headers) {
        return this.headers.map(header => header.text);
      }

      return this.items[0] ? Object.keys(this.items[0]) : [];
    },
    computedUrl() {
      let url = this.url;

      Object.keys(this.filters).forEach((key) => {
        if (![null,undefined].includes(this.filters[key])) {
          url += `&filter[${key}]=${this.filters[key]}`;
        }
      });
      return url;
    },
    loading() {
      return this.fetchTimeout !== null;
    }
  },
  watch: {
    computedUrl() {
      this.fetch();
    }
  },
  beforeDestroy() {
    this.$off('filter-update');
  }
}
</script>
